import { PUBLIC_NODE_ENV, PUBLIC_SENTRY_DSN } from '$env/static/public';
import * as Sentry from '@sentry/sveltekit';
import type { HandleClientError } from '@sveltejs/kit';

Sentry.init({
  dsn: PUBLIC_SENTRY_DSN,
  environment: PUBLIC_NODE_ENV,
  enabled: PUBLIC_NODE_ENV !== 'development',
  beforeSend(event) {
    event.tags = { ...event.tags, hooks: 'client' };
    return event;
  },
});

const reportError = Sentry.handleErrorWithSentry();

export const handleError: HandleClientError = (input) => {
  const errorId = window.crypto.randomUUID();
  Sentry.withScope((scope) => {
    scope.setTag('errorId', errorId);
    reportError({ ...input, event: input.event as any });
  });
  return {
    message: input.error as any,
    errorId,
  };
};
